import React from 'react'

const MaintenancePage: React.FC = () => {
  const handleBackToApp = () => {
    window.location.reload() // This will reload the page, useful when maintenance is disabled
  }

  return (
    <div
      className='min-vh-100 d-flex align-items-center justify-content-center p-4'
      style={{
        backgroundColor: '#f8fafc',
      }}
    >
      <div className='container'>
        <div className='row justify-content-center'>
          <div className='col-12 col-md-10 col-lg-8 col-xl-6'>
            <div
              className='card border-0 shadow-sm'
              style={{
                borderRadius: '1rem',
                backgroundColor: '#ffffff',
              }}
            >
              <div className='card-body p-5 p-md-6'>
                <div className='text-center'>
                  {/* HMS Logo */}
                  <div className='mb-5'>
                    <img
                      src='/hms.png'
                      alt='HMS Logo'
                      style={{width: '300px'}}
                      className='mx-auto d-block'
                    />
                  </div>

                  {/* Maintenance Icon */}
                  <div className='mb-5'>
                    <div
                      className='d-flex align-items-center justify-content-center mx-auto rounded-circle'
                      style={{
                        width: '4.5rem',
                        height: '4.5rem',
                        backgroundColor: '#fef3c7',
                      }}
                    >
                      <svg
                        width='36'
                        height='36'
                        viewBox='0 0 24 24'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z'
                          stroke='#d97706'
                          strokeWidth='2'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                        />
                      </svg>
                    </div>
                  </div>

                  {/* Maintenance Message */}
                  <div className='mb-4'>
                    <h1 className='h2 fw-bold text-dark mb-4'>System Maintenance</h1>
                  </div>

                  <p className='fs-5 text-muted mb-5 lh-base px-2'>
                    We're currently performing scheduled maintenance to improve our services. We'll
                    be back online shortly.
                  </p>

                  {/* Information Box */}
                  <div className='mb-5'>
                    <div
                      className='p-4 rounded-3'
                      style={{
                        backgroundColor: '#f0f9ff',
                        border: '1px solid #e0f2fe',
                      }}
                    >
                      <div className='d-flex align-items-center justify-content-center mb-2'>
                        <svg
                          width='20'
                          height='20'
                          viewBox='0 0 24 24'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                          className='me-2'
                        >
                          <path
                            d='M12 2L15.09 8.26L22 9L17 14.74L18.18 21.02L12 17.77L5.82 21.02L7 14.74L2 9L8.91 8.26L12 2Z'
                            fill='#0369a1'
                          />
                        </svg>
                        <h6 className='mb-0 fw-semibold text-primary'>Estimated Completion</h6>
                      </div>
                      <p className='mb-0 text-muted'>
                        We expect to complete maintenance soon. Thank you for your patience.
                      </p>
                    </div>
                  </div>

                  {/* Back Button */}
                  <div className='mb-4'>
                    <button
                      onClick={handleBackToApp}
                      className='btn btn-primary btn-lg px-5 py-3 fw-semibold'
                      style={{
                        borderRadius: '0.75rem',
                        border: 'none',
                      }}
                    >
                      <svg
                        width='18'
                        height='18'
                        viewBox='0 0 24 24'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                        className='me-2'
                      >
                        <path
                          d='M19 12H5M12 19L5 12L12 5'
                          stroke='currentColor'
                          strokeWidth='2'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                        />
                      </svg>
                      Back to Application
                    </button>
                  </div>

                  {/* Contact Information */}
                  <div className='pt-4 border-top' style={{borderColor: '#e5e7eb'}}>
                    <div className='text-muted'>
                      <svg
                        width='16'
                        height='16'
                        viewBox='0 0 24 24'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                        className='me-2'
                      >
                        <path
                          d='M12 6V12L16 14'
                          stroke='currentColor'
                          strokeWidth='1.5'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                        />
                        <circle cx='12' cy='12' r='9' stroke='currentColor' strokeWidth='1.5' />
                      </svg>
                      <span>For urgent matters, please check back shortly</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MaintenancePage
